import { useState } from 'react';
import SiteImage from './SiteImage';
import SafeIcon from '../common/SafeIcon';
import './guest-updates.css';

export default function RoomCarousel({ room }) {
  const [active, setActive] = useState(0);
  const images = room.images?.length ? room.images : [room.image];
  const previous = () => setActive((index) => (index - 1 + images.length) % images.length);
  const next = () => setActive((index) => (index + 1) % images.length);

  return (
    <div className="room-carousel" aria-label={`${room.title} photos`}>
      <div className="room-detail-image">
        <SiteImage src={images[active]} alt={`${room.title} photo ${active + 1} of ${images.length}`} />
        {images.length > 1 && (
          <div className="room-carousel-controls">
            <button type="button" onClick={previous} aria-label="Previous room image"><SafeIcon name="ChevronLeft" /></button>
            <span>{active + 1} / {images.length}</span>
            <button type="button" onClick={next} aria-label="Next room image"><SafeIcon name="ChevronRight" /></button>
          </div>
        )}
      </div>
      {images.length > 1 && <div className="room-carousel-thumbs">{images.map((src, index) => (
        <button type="button" key={`${src}-${index}`} onClick={() => setActive(index)} aria-label={`Show room image ${index + 1}`} aria-current={active === index ? 'true' : undefined}>
          <SiteImage src={src} alt={`${room.title} thumbnail ${index + 1}`} />
        </button>
      ))}</div>}
    </div>
  );
}